"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductFilterStore = void 0;
const pinia_1 = require("pinia");
const ProductFilter_1 = require("../../../models/ProductFilter");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const productFilterHelper_1 = require("./productFilterHelper");
const DropdownInputItem_1 = __importDefault(require("../../../components/Form/DropdownInput/DropdownInputItem"));
const SearchInputOption_1 = __importDefault(require("../../../components/Form/SearchInput/SearchInputOption"));
const i18n_1 = require("../../../common/i18n");
exports.useProductFilterStore = (0, pinia_1.defineStore)('productFilterStore', {
    state: () => ({
        loading: false,
        productFilters: null,
    }),
    getters: {
        loadIndexesDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.loadIndexes) {
                return [];
            }
            let loadIndexes = [];
            const loadIndexesValues = state.productFilters.loadIndexes.values;
            if (Array.isArray(loadIndexesValues)) {
                loadIndexes = loadIndexesValues.map((loadIndex) => {
                    return new DropdownInputItem_1.default(String(loadIndex), String(loadIndex));
                });
            }
            return loadIndexes;
        },
        speedIndexesDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.speedIndexes) {
                return [];
            }
            let speedIndexes = [];
            const speedIndexesValues = state.productFilters.speedIndexes.values;
            if (Array.isArray(speedIndexesValues)) {
                speedIndexes = speedIndexesValues.map((speedIndex) => {
                    return new DropdownInputItem_1.default(String(speedIndex), String(speedIndex));
                });
            }
            return speedIndexes;
        },
        treadCodeSearchInputOptions: (state) => {
            if (state.productFilters === null || !state.productFilters.treadCodes) {
                return [];
            }
            const treadCodesValues = state.productFilters.treadCodes.values;
            if (!Array.isArray(treadCodesValues)) {
                return [];
            }
            return treadCodesValues.map((treadCode) => {
                return new SearchInputOption_1.default(String(treadCode), String(treadCode));
            });
        },
        nameAliasSearchInputOptions: (state) => {
            if (state.productFilters === null || !state.productFilters.nameAliases) {
                return [];
            }
            const nameAliasesValues = state.productFilters.nameAliases.values;
            if (!Array.isArray(nameAliasesValues)) {
                return [];
            }
            return nameAliasesValues.map((nameAlias) => {
                return new SearchInputOption_1.default(String(nameAlias), String(nameAlias));
            });
        },
        idSearchInputOptions: (state) => {
            if (state.productFilters === null || !state.productFilters.ids) {
                return [];
            }
            const idsValues = state.productFilters.ids.values;
            if (!Array.isArray(idsValues)) {
                return [];
            }
            return idsValues.map((id) => {
                return new SearchInputOption_1.default(String(id), String(id));
            });
        },
        eanSearchInputOptions: (state) => {
            if (state.productFilters === null || !state.productFilters.eans) {
                return [];
            }
            const eansValues = state.productFilters.eans.values;
            if (!Array.isArray(eansValues)) {
                return [];
            }
            return eansValues.map((ean) => {
                return new SearchInputOption_1.default(String(ean), String(ean));
            });
        },
        manufacturerSkuSearchInputOptions: (state) => {
            if (state.productFilters === null || !state.productFilters.manufacturerSkus) {
                return [];
            }
            const manufacturerSkusValues = state.productFilters.manufacturerSkus.values;
            if (!Array.isArray(manufacturerSkusValues)) {
                return [];
            }
            return manufacturerSkusValues.map((manufacturerSku) => {
                return new SearchInputOption_1.default(String(manufacturerSku), String(manufacturerSku));
            });
        },
        brandDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.brands) {
                return [];
            }
            let brands = [];
            const brandsValues = state.productFilters.brands.values;
            if (typeof brandsValues === 'object' && brandsValues !== null && !Array.isArray(brandsValues)) {
                for (let key in brandsValues) {
                    const value = brandsValues[key];
                    brands.push(new DropdownInputItem_1.default(key, value && value.length > 0 ? value : key));
                }
            }
            return brands;
        },
        widthDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.widths) {
                return [];
            }
            let widths = [];
            const widthsValues = state.productFilters.widths.values;
            if (Array.isArray(widthsValues)) {
                widths = widthsValues.map((width) => {
                    return new DropdownInputItem_1.default(String(width), String(width));
                });
            }
            return widths;
        },
        profileDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.profiles) {
                return [];
            }
            let profiles = [];
            const profilesValues = state.productFilters.profiles.values;
            if (Array.isArray(profilesValues)) {
                profiles = profilesValues.map((profile) => {
                    return new DropdownInputItem_1.default(String(profile), String(profile));
                });
            }
            return profiles;
        },
        diameterDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.diameters) {
                return [];
            }
            let diameters = [];
            const diametersValues = state.productFilters.diameters.values;
            if (Array.isArray(diametersValues)) {
                diameters = diametersValues.map((diameter) => {
                    return new DropdownInputItem_1.default(String(diameter), String(diameter));
                });
            }
            return diameters;
        },
        widthPairDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.widthsPair) {
                return [];
            }
            let options = [];
            const widthsPairValues = state.productFilters.widthsPair.values;
            if (Array.isArray(widthsPairValues)) {
                widthsPairValues.forEach((value) => {
                    if (typeof value !== 'string' && typeof value !== 'number') {
                        return;
                    }
                    options.push(new DropdownInputItem_1.default(String(value), String(value)));
                });
            }
            return options;
        },
        profilePairDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.profilesPair) {
                return [];
            }
            let options = [];
            const profilesPairValues = state.productFilters.profilesPair.values;
            if (Array.isArray(profilesPairValues)) {
                profilesPairValues.forEach((value) => {
                    if (typeof value !== 'string' && typeof value !== 'number') {
                        return;
                    }
                    options.push(new DropdownInputItem_1.default(String(value), String(value)));
                });
            }
            return options;
        },
        diameterPairDropdownInputItems: (state) => {
            if (state.productFilters === null || !state.productFilters.diametersPair) {
                return [];
            }
            let options = [];
            const diametersPairValues = state.productFilters.diametersPair.values;
            if (Array.isArray(diametersPairValues)) {
                diametersPairValues.forEach((value) => {
                    if (typeof value !== 'string' && typeof value !== 'number') {
                        return;
                    }
                    options.push(new DropdownInputItem_1.default(String(value), String(value)));
                });
            }
            return options;
        },
        itemCount: (state) => {
            var _a;
            if (state.productFilters === null) {
                return 0;
            }
            const value = (_a = state.productFilters.itemCount) === null || _a === void 0 ? void 0 : _a.values;
            return typeof value === 'number' ? value : 0;
        },
        axCategoriesDropdownInputItems: () => {
            return [
                new DropdownInputItem_1.default("140", (0, i18n_1.trans)("product_filter_summer_passenger_tyre", "Summer passenger tyre", 'product_filter')),
                new DropdownInputItem_1.default("130", (0, i18n_1.trans)("product_filter_small_truck_tyre", "Small truck tyre", 'product_filter')),
                new DropdownInputItem_1.default("131", (0, i18n_1.trans)("product_filter_4x4_summer_tyre", "4x4 summer tyre", 'product_filter')),
                new DropdownInputItem_1.default("145", (0, i18n_1.trans)("product_filter_all_season_passenger_tyre", "All season passenger tyre", 'product_filter')),
                new DropdownInputItem_1.default("135", (0, i18n_1.trans)("product_filter_all_season_small_truck_tyre", "All season small truck tyre", 'product_filter')),
                new DropdownInputItem_1.default("133", (0, i18n_1.trans)("product_filter_4x4_all_season_tyre", "4x4 all season tyre", 'product_filter')),
                new DropdownInputItem_1.default("149", (0, i18n_1.trans)("product_filter_winter_passanger_tyre", "Winter passenger tyre", 'product_filter')),
                new DropdownInputItem_1.default("139", (0, i18n_1.trans)("product_filter_winter_small_truck_tyre", "Winter small truck tyre", 'product_filter')),
                new DropdownInputItem_1.default("138", (0, i18n_1.trans)("product_filter_4x4_winter_tyre", "4x4 winter tyre", 'product_filter')),
                new DropdownInputItem_1.default("122", (0, i18n_1.trans)("product_filter_truck_tyre_dc", "Truck tyre DC", 'product_filter')),
                new DropdownInputItem_1.default("120", (0, i18n_1.trans)("product_filter_truck_tyre_20", "Truck tyre 20", 'product_filter')),
                new DropdownInputItem_1.default("110", (0, i18n_1.trans)("product_filter_agricultural_tyre", "Agricultural tyre", 'product_filter')),
                new DropdownInputItem_1.default("160", (0, i18n_1.trans)("product_filter_industrial_tyre", "Industrial tyre", 'product_filter')),
                new DropdownInputItem_1.default("150", (0, i18n_1.trans)("product_filter_forklift_tyre", "Forklift tyre", 'product_filter')),
                new DropdownInputItem_1.default("170", (0, i18n_1.trans)("product_filter_motorcycle_tyre", "Motorcycle tyre", 'product_filter')),
                new DropdownInputItem_1.default("123", (0, i18n_1.trans)("product_filter_MHO_retreaded_tyre", "MHO retreaded tyre", 'product_filter')),
            ];
        }
    },
    actions: {
        async getProductFilters(router, filterParams) {
            this.loading = true;
            if (router.currentRoute.value.name !== 'shop_sku_search' &&
                router.currentRoute.value.name !== 'product_return_guarantee' &&
                router.currentRoute.value.name !== 'product_return_customer') {
                filterParams.active = 1;
            }
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_product_filter_values_api', query: filterParams }).href);
                let filters = new ProductFilter_1.ProductFilters();
                Object.keys(response).forEach(key => {
                    filters[key] = new ProductFilter_1.ProductFilter(key, response[key]);
                });
                const filterParamsSizeSlug = (filterParams.sizeSlug || []);
                // Ha legalább két sizeSlug van, az páros keresésnek számít.
                if (filterParamsSizeSlug.length > 1 && filters.sizeSlugs) {
                    let matchedSlugs = (0, productFilterHelper_1.calculateMatchedSlugs)(filterParamsSizeSlug[0], filters.sizeSlugs);
                    let resultMap = (0, productFilterHelper_1.calculateSizeOptions)(matchedSlugs);
                    filters.widths = new ProductFilter_1.ProductFilter('widths', Array.from(resultMap.widths).sort());
                    filters.profiles = new ProductFilter_1.ProductFilter('profiles', Array.from(resultMap.profiles).sort());
                    filters.diameters = new ProductFilter_1.ProductFilter('diameters', Array.from(resultMap.diameters).sort());
                    matchedSlugs = (0, productFilterHelper_1.calculateMatchedSlugs)(filterParamsSizeSlug[1], filters.sizeSlugs);
                    resultMap = (0, productFilterHelper_1.calculateSizeOptions)(matchedSlugs);
                    filters.widthsPair = new ProductFilter_1.ProductFilter('widthsPair', Array.from(resultMap.widths).sort());
                    filters.profilesPair = new ProductFilter_1.ProductFilter('profilesPair', Array.from(resultMap.profiles).sort());
                    filters.diametersPair = new ProductFilter_1.ProductFilter('diametersPair', Array.from(resultMap.diameters).sort());
                }
                this.productFilters = filters;
                return filters;
            }
            catch (error) {
                console.error('Error fetching product filters:', error);
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async getBrandPriceCategories(router) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_products_brand_price_categories' }).href);
                return response;
            }
            catch (error) {
                console.error('Error fetching brand price categories:', error);
                throw error;
            }
        },
        reset() {
            this.loading = false;
            this.productFilters = null;
        }
    }
});
